import { Type } from '@sinclair/typebox';
import { LiftPlanSchema } from '../../domain/lift-plan/lift-plan-schema.js';
import { NullishType } from '../../standard-schema.js';
export { LiftPlanEntrySchema, LiftPlanSchema, LiftPlanSubtotalSchema, } from '../../domain/lift-plan/lift-plan-schema.js';
export const GetLiftPlanResponseSchema = LiftPlanSchema;
export const GetLiftPlanSchema = LiftPlanSchema;
export const PutLiftPlanResponseSchema = LiftPlanSchema;
export const LiftPlanParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const PutLiftPlanBodyEntrySchema = Type.Object({
    number: Type.Number(),
    description: NullishType(Type.String()),
    dueDate: NullishType(Type.String()),
    amount: Type.Number(),
    retention: Type.Number(),
    amountDue: Type.Number(),
    invoicedDate: NullishType(Type.String()),
    paymentDate: NullishType(Type.String()),
    comment: NullishType(Type.String()),
});
export const PutLiftPlanBodySubtotalSchema = Type.Object({
    description: Type.String(),
    amount: Type.Number(),
});
export const PutLiftPlanBodySchema = Type.Object({
    retentionPercentage: Type.Number(),
    entries: Type.Array(PutLiftPlanBodyEntrySchema),
    subtotals: Type.Array(PutLiftPlanBodySubtotalSchema),
});
